module.exports = __webpack_public_path__ + "media/2.cc4e8b3e.mp3";